import type { ReactNode } from "react";
import { cn } from "../lib/cn";

type Tone = "outline" | "solid" | "accent";

const TONES: Record<Tone, string> = {
  outline: "border-hairline bg-subtle text-body",
  solid: "border-transparent bg-subtle text-body",
  accent: "border-accent-soft bg-accent-surface text-accent-strong",
};

/** Tech-spec chip. Rows of these carry a project's stack and a skill group's tools. */
export function Tag({
  tone = "outline",
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1.5 text-xs leading-snug font-medium",
        TONES[tone],
      )}
    >
      {children}
    </span>
  );
}
